import { Flex, Icon, Tooltip, TooltipProps, useDisclosure } from '@chakra-ui/react'

export interface HelpTooltipProps extends Omit<TooltipProps, 'children'> {
  children?: React.ReactNode
  label: string | React.ReactNode
}

const HelpTooltip = ({ label, placement = 'top', ...props }: HelpTooltipProps) => {
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure()

  return (
    <Tooltip hasArrow label={label} placement={placement} isOpen={isOpen} {...props}>
      <Flex cursor="pointer" alignItems="center" onMouseEnter={onOpen} onMouseLeave={onClose} onClick={onToggle}>
        <Icon w={4} h={4} color={isOpen ? 'text.secondary' : 'text.tertiary'} ml="6px" />
      </Flex>
    </Tooltip>
  )
}

export default HelpTooltip
